import ContentText from './content-text';

export default async function init() {
  const elements = document.querySelectorAll("[data-js-module='content-text']");

  if (elements) {
    elements.forEach((element) => new ContentText(element));
  }
}
